import globalStyles from '@/styles/index.module.css';
import { flushColumnState, sizeColumnsOnFirstVisit } from '@/utils/flushColumnState';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import Table from '@nautilusbio/nb-design-system/Table';
import { Text } from '@nautilusbio/nb-design-system/Text';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useRunTableColDefs } from '../../helpers';
import irStyles from '../../styles.module.css';
import type { Sample } from '../../types';

interface Props {
  id: string;
  samples: Sample[];
}

const RunControlsAndSamples = ({ id, samples }: Props) => {
  const { t } = useTranslation('runs', { keyPrefix: 'header' });
  const colDefs = useRunTableColDefs();

  const controls = samples.filter(s => s.is_control === true);
  const nonControls = samples.filter(s => s.is_control !== true);

  const controlsTableId = `${id}-controls-table`;
  const samplesTableId = `${id}-samples-table`;

  return (
    <Stack fullWidth gap={6} orientation="vertical">
      {controls.length > 0 && (
        <Stack className={irStyles.samplesTableContainer} fullWidth gap={4} orientation="vertical">
          <Text as="h3">{t('controls')}</Text>
          <Stack className={clsx(irStyles.samplesTable, globalStyles.scrollbars)} fullWidth>
            <Table
              tableId={controlsTableId}
              columnDefs={colDefs}
              domLayout="autoHeight"
              enableAdvancedFilter={false}
              enableResponsiveResize={false}
              onGridReady={e => sizeColumnsOnFirstVisit(e.api, controlsTableId)}
              onGridPreDestroyed={e => flushColumnState(e.api, controlsTableId)}
              resizeDebounceMs={150}
              rowData={controls}
            />
          </Stack>
        </Stack>
      )}

      {nonControls.length > 0 && (
        <Stack className={irStyles.samplesTableContainer} fullWidth gap={4} orientation="vertical">
          <Text as="h3">{t('samples')}</Text>
          <Stack className={clsx(irStyles.samplesTable, globalStyles.scrollbars)} fullWidth>
            <Table
              tableId={samplesTableId}
              columnDefs={colDefs}
              domLayout="autoHeight"
              enableAdvancedFilter={false}
              enableResponsiveResize={false}
              onGridReady={e => sizeColumnsOnFirstVisit(e.api, samplesTableId)}
              onGridPreDestroyed={e => flushColumnState(e.api, samplesTableId)}
              resizeDebounceMs={150}
              rowData={nonControls}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default RunControlsAndSamples;
